// Guia de tamanhos (<size-guide>): o dialog que o "Qual tamanho
// escolher?" abre, com as medidas de cada tamanho da tabela do produto.
//
// Trocar o tamanho à vista é do CSS (rádios, ver snippets/size-guide).
// Aqui ficam abrir, fechar com a saída animada e abrir no tamanho que a
// página tem marcado.

// Covers a transition that never fires (display: none ancestors, etc.).
const CLOSE_FALLBACK = 400;

// Plays the exit while the dialog is still open, then really closes it.
// Same helper as cart.js, header.js and quick-view.js, duplicated on
// purpose so each module stays self-contained: change one, change the others.
function closeDialog(dialog) {
  if (!dialog?.open || dialog.hasAttribute('closing')) return;
  dialog.setAttribute('closing', '');
  const finish = () => {
    clearTimeout(timer);
    dialog.removeEventListener('transitionend', finish);
    dialog.removeAttribute('closing');
    dialog.close();
  };
  const timer = setTimeout(finish, CLOSE_FALLBACK);
  dialog.addEventListener('transitionend', finish);
}

class SizeGuide extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;
    this.controller = new AbortController();
    const { signal } = this.controller;

    // O link mora na linha do título do tamanho, que a troca de variante
    // refaz com o HTML do servidor: o clique é ouvido no documento.
    document.addEventListener('click', this.handleOpen, { signal });
    this.addEventListener('click', (event) => {
      // Clicking the backdrop means clicking the dialog itself.
      if (event.target === this.dialog || event.target.closest('[data-close]')) closeDialog(this.dialog);
    }, { signal });
    // Escape fires cancel: hold the instant close, play the exit instead.
    this.dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog(this.dialog);
    }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  handleOpen = (event) => {
    const trigger = event.target.closest('[data-size-guide]');
    if (!trigger || trigger.getAttribute('aria-controls') !== this.dialog.id) return;
    event.preventDefault();
    this.selectPageSize();
    this.dialog.showModal();
  };

  // O tamanho marcado na página muda depois que o guia nasce; se a tabela
  // o tem, é nele que o guia abre. Produto com duas tabelas marca nas
  // duas: cada uma é um grupo de rádios.
  selectPageSize() {
    const group = this.dataset.sizeGroup;
    if (!group) return;
    const picked = document.querySelector(`input[name="${CSS.escape(group)}"]:checked`)?.value;
    const key = picked?.trim().toLowerCase();
    this.querySelectorAll('[data-size]').forEach((input) => {
      if (input.value.trim().toLowerCase() === key) input.checked = true;
    });
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide);
}
